import { Box, styled } from "@mui/system";
import Toolbar from "@mui/material/Toolbar";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

import { colors, others } from "../../styles/colors";

export const HeaderToolbar: any = styled(Toolbar)((props) => ({
  minHeight: "2.8rem",
  display: "flex",
  backgroundColor: others.HeaderMenu[2],
  justifyContent: "space-between",
  [props.theme.breakpoints.up("sm")]: {
    minHeight: "2.8rem",
  },
}));

export const IconFaInfoAlt = styled(FaCheckCircle)(() => ({
  color: colors.fonts[18],
  cursor: "pointer",
  width: "1rem",
  height: "1rem",
}));

export const NavLine = () => ({
  width: "6rem",
  height: 0,
  border: `1px dotted ${colors.circleBorder.border}`,
  zIndex: 1,
});

export const StageCircle = () => ({
  border: `1px solid ${colors.circleBorder.border}`,
  borderRadius: "100%",
  width: "1.3rem",
  height: "1.3rem",
  lineHeight: "1.3rem",
  textAlign: "center",
  zIndex: 2,
  opacity: 0.8,
  borderColor: "none",
  backgroundColor: colors.white[1],
});

export const priorAuthHeader = {
  backgroundColor: colors.backgroundColor[10],
  padding: "0.5rem 0 2rem 0",
  minHeight: "5.4rem",
  alignItems: "center",
};

export const PanelSectionBox = styled(Box)(() => ({
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  backgroundColor: colors.white[1],
  borderRadius: "10px",
  marginBottom: "1rem",
}));

export const PatientInfoReferralGrid = () => ({
  display: "block",
  padding: "0 0.8rem 0 1.8rem",
  zIndex: 10,
  position: "relative",
  top: "-1.2rem",
  width: "99%",
});

export const PatientInfoPanelBox = styled(Box)(() => ({
  padding: "1.2rem 1.5rem 1rem 1.5rem",
}));

export const PatientInfoDivider = {
  margin: "0 1.2rem",
  height: "2rem",
  align: "left",
};

export const LogoLink = styled(Link)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const LogoImg = styled("img")(() => ({
  width: "auto",
  paddingLeft: "1.5rem",
  height: "1.7rem",
}));

export const HeaderUserDetails = () => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  gap: "0.3rem",
});

export const HeaderContainer = () => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "center",
  paddingTop: "0.2rem",
});

export const PatientDetailsContainer = () => ({
  backgroundColor: colors.white[1],
  width: "100%",
  height: "3.3rem ",
  display: "flex",
  alignItems: "center",
  border: `1px solid ${colors.borders[2]}`,
  borderRadius: "0.3rem",
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  gap: "2rem",
  bottom: "2rem",
  position: "relative",
});

export const PatientDetailsDivider = () => ({
  height: "1.5rem",
  border: `1px solid ${colors.borders[2]}`,
});

export const EligibilityBox = () => ({
  border: `1px solid ${colors.circleBorder.border}`,
  borderRadius: "100%",
  padding: "0.12rem 0.1rem 0.1rem 0.13rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.white[1],
});

export const StatusContainer = () => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  paddingRight: "2rem",
});

export const StickyContainer = () => ({
  display: "flex",
  justifyContent: "center",
  padding: "0  1.5rem",
  top: "2.5rem",
  position: "sticky",
  zIndex: 2,
});

export const BackdropSection = () => ({
  zIndex: 20,
});

export const OuterGrid = () => ({
  backgroundColor: colors.backgroundColor[14]
});
